<template>
  <div class="main-content">
    <div class="row" v-if="order">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5>Обработка заявки <strong>{{ order.id }}</strong>
            </h5>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5>Клиент</h5>
          </div>
          <div class="card-body">
            <clientCard
              :client="order.client"
              :phones="order.phones"
            />
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Препараты</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <drugSelect
                  :drugs="order.details"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import clientCard from "../../../components/clients/clientCard";
import drugSelect from "../../../components/orders/drugSelect";

export default {
  components: {
    clientCard,
    drugSelect,
  },
  data() {
    return {
      order: null
    }
  },
  async mounted() {
    await this.getOrder()
  },
  methods: {
    async getOrder() {
      let {data} = await api.index('/orders/getOrder?id=' + this.$route.params.id);
      this.order = data.order;
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
</style>
